/* template */
<template><div class="mpx-root-view"><div class="es-content"><div class="es-content__box es-content__card"><es-card custom-body="es-content__miniapp_card_body"><div v-for="(item, index) in (registerContentData)"><component :is="(item.component)" :isShow="(item.isShow)" :item="(item)" :value="baseData[item.name]" mpxModelEvent="input" @mpxModel='__model("baseData."+item.name, $event, ["value"], undefined)' :isRequiredShow="(isRequiredShow)" :selectedCardList="(selectedCardList)" :isNeedCard="(isNeedCard)" :cardType="(cardType)" :baseData="(baseData)"/></div></es-card></div></div><successDialog :show="(showDialog)" :account="(nickname)" :password="(password)" @confirm="gotologin"/><failDialog :show="(showFailDialog)" @confirm="gocurrent" :msg="(failmsg)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m0200f898"}'>
  +b('content')
    /deep/ .mpx-picker-panel
      border-radius 10px
    /deep/ .mpx-input
      outline none
      background none
      box-shadow none
      -webkit-tap-highlight-color rgba(255,0,0,0)
    /deep/ .es-content__name
      margin-right 0
      width 74px
    /deep/ .es-content__name-field
      width 100%
    /deep/ .es-field
      width 100%  
    /deep/ .es-content__name-text-border
      width calc(100% - 80px)
      right 10px
    +e('box')
      margin 12px
      position relative
    +e('card')
      background-color #ffffff
      border-radius 8px
      color #333333
      /deep/ .item-style
        margin-bottom 0
      /deep/ .placeholder
        color #999999
      // h5用
      /deep/ .es-card__header
        line-height 38px
        font-size 16px
        font-weight bold
        margin 4px 12px
        padding 0
        border-bottom 0.5px solid rgba(235, 237, 240, 0.6)
      // h5用
      /deep/ .es-cell
        height 54px
        color #333333
        padding 10px 0
        &::after
          border-bottom 1px solid #f0f2f7
          left 76px
          right 0
      // h5用
      /deep/ .es-cell:last-child
        // &::after
        // border-bottom none
      // h5用
      /deep/ .es-cell-custom
        height 44px
        &::after
          border-bottom 1px solid #eeeeee
          left 0
          right 0
      // h5用
      /deep/ .es-cell-custom:last-child
        &::after
          border-bottom 1px solid #eeeeee
      // h5用
      /deep/ .es-field__body
        color #333333 !important
    // 小程序用
    +e('miniapp_card_header')
      line-height 38px
      font-size 16px
      font-weight bold
      margin 4px 12px
      padding 0
    // 小程序用
    +e('miniapp_card_body')
      padding 0 12px
    // 小程序用
    +e('tip-text')
      color #999999
      font-size 12px
      text-align justify
    +e('tips-icon')
      font-size 12px
      line-height 17px
      margin-right 3px
      color #999999
    +e('name-tips')
      display flex
      justify-content space-between
      align-items center
      margin -4px -12px 0 -12px
      padding 0 12px
      height 32px
      background-image linear-gradient(270deg, #FFFFFF 0%, #FFF4EE 100%)
    +e('name-tips-content')
      font-family PingFangSC-Regular
      font-size 12px
      color #FF6221
    +e('name-tips-entrance')
      display flex
      align-items center
      font-family PingFangSC-Regular
      font-size 12px
      color #666666
      text-align right
      line-height 12px
    +e('change')
      position absolute
      z-index 1
      top 80px
      right 12px

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0200f898"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex0200f898%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex0200f898%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0200f898"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index0200f898/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'successDialog':getComponent(require("./success-dialog.mpx?isComponent&outputPath=components%2Fsuccess-dialog06d7bf44%2Findex")),'failDialog':getComponent(require("./fail-dialog.mpx?isComponent&outputPath=components%2Ffail-dialogafb93a0e%2Findex")),'es-button':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex")),'es-icon':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-contact-type':getComponent(require("../../../contact/components/content/components/contact-type.mpx?isComponent&outputPath=components%2Fcontact-type3df7ee35%2Findex")),'es-english-surname':getComponent(require("../../../contact/components/content/components/english-surname.mpx?isComponent&outputPath=components%2Fenglish-surnamec4c09c84%2Findex")),'es-english-name':getComponent(require("../../../contact/components/content/components/english-name.mpx?isComponent&outputPath=components%2Fenglish-name96f92694%2Findex")),'es-birth-date':getComponent(require("../../../contact/components/content/components/birth-date.mpx?isComponent&outputPath=components%2Fbirth-date51bee4aa%2Findex")),'es-contact-sex':getComponent(require("../../../contact/components/content/components/contact-sex.mpx?isComponent&outputPath=components%2Fcontact-sex3ff66779%2Findex")),'es-contact-remark':getComponent(require("../../../contact/components/content/components/contact-remark.mpx?isComponent&outputPath=components%2Fcontact-remarkeb471b0a%2Findex")),'es-card-list':getComponent(require("../../../contact/components/content/components/card-list.mpx?isComponent&outputPath=components%2Fcard-list4c87468a%2Findex")),'es-save-switch':getComponent(require("../../../contact/components/content/components/save-switch.mpx?isComponent&outputPath=components%2Fsave-switch5ee5a378%2Findex")),'es-tip-text':getComponent(require("../../../contact/components/content/components/tip-text.mpx?isComponent&outputPath=components%2Ftip-textbb5fc7e6%2Findex")),'es-change-btn':getComponent(require("../../../contact/components/content/components/change-btn.mpx?isComponent&outputPath=components%2Fchange-btnb8b68426%2Findex")),'es-card':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/card/index.mpx?isComponent&outputPath=components%2Findex340a2e8c%2Findex")),'es-contact-name':getComponent(require("../../../contact/components/content/components/contact-name12306.mpx?isComponent&outputPath=components%2Fcontact-name123060b145aa0%2Findex")),'es-contact-phone':getComponent(require("../../../contact/components/content/components/contact-phone12306.mpx?isComponent&outputPath=components%2Fcontact-phone1230623c45705%2Findex")),'es-expire-date':getComponent(require("../../../contact/components/content/components/expire-date.mpx?isComponent&outputPath=components%2Fexpire-date693aaf48%2Findex")),'es-contact-nickname12306':getComponent(require("../../../contact/components/content/components/contact-nickname12306.mpx?isComponent&outputPath=components%2Fcontact-nickname123060e73d61d%2Findex")),'es-nationlity':getComponent(require("../../../contact/components/content/components/nationlity12306.mpx?isComponent&outputPath=components%2Fnationlity123060674eb8f%2Findex")),'es-password':getComponent(require("../../../contact/components/content/components/password.mpx?isComponent&outputPath=components%2Fpasswordfd0c2cee%2Findex")),'es-confirm-password':getComponent(require("../../../contact/components/content/components/confirm-password.mpx?isComponent&outputPath=components%2Fconfirm-password31170876%2Findex")),'es-email':getComponent(require("../../../contact/components/content/components/email.mpx?isComponent&outputPath=components%2Femail1e77131c%2Findex")),'es-card-type':getComponent(require("../../../contact/components/content/components/card-type.mpx?isComponent&outputPath=components%2Fcard-type61378d57%2Findex")),'es-id-no':getComponent(require("../../../contact/components/content/components/id-no.mpx?isComponent&outputPath=components%2Fid-no128cb3b3%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
